import { useState, useEffect } from "react";
import {
  saveCustomerDetails,
  getAllCustomerTypes,
  getAllCountries,
  getRegionsByCountry,
  getDistrictsByRegion,
  getTehsilsByDistrict,
  getCitiesByTehsil,
  getAllCurrencies,
  getAllMerchants,
  getAllResources,
  getCompanyCodesByOrganisation,
  getCustomerTypebyOrgId,
} from "../Api/CustomerMaster";
import { fetchResourceByOrgId } from "../Api/InvoiceApi";
import {
  Container,
  Form,
  Button,
  Row,
  Col,
  Accordion,
  AccordionItem,
  AccordionBody,
} from "react-bootstrap";
import { toast } from "react-toastify";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
/*import  "../Styling/CustomerMaster.css"*/
import "../Styling/Title.css";
import "../Styling/Accordion.css";
import "../Styling/SaveButton.css";
const CustomerMaster = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [dropdownData, setDropdownData] = useState({
    companyCodes: [],
    customerTypes: [],
    countries: [],
    currencies: [],
    merchants: [],
    resources: [],
    regions: [],
    districts: [],
    tehsils: [],
    cities: [],
  });
  const [showGstFields, setShowGstFields] = useState(false);
  const [showTaxId, setShowTaxId] = useState(false);

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  const organisationId = userDetails?.organisationId; // Get organisationId from localStorage

  const [customerData, setCustomerData] = useState({
    organisationId: organisationId || "", // Set organisationId from localStorage
    companyCode: "",
    customerType1: "",
    name: "",
    countryCode: "",
    regionName: "",
    districtName: "",
    tehsilName: "",
    cityName: "",
    registeredInGst: "",
    taxId: "",
    address1: "",
    address2: "",
    address3: "",
    clientBy: "",
    parentAccount: "",
    defaultTdsPercent: "",
    currency: "",
    paymentTransaction: "",
    active: "Yes",
    shortNames: "",
    vendorCode: "",
    salespersonCode: "",
    leadType: "",
    leadReference: "",
    currentAccountManager: "",
    creditLimit: "1",
    mobileNumber: "",
    pinCode: "",
  });

  // Store the actual codes separately for submission
  const [locationCodes, setLocationCodes] = useState({
    regionCode: "",
    districtCode: "",
    tehsilCode: "",
    cityCode: "",
  });

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        setLoading(true);
        const [customerTypes, countries, currencies, merchants, resources] =
          await Promise.all([
            getCustomerTypebyOrgId(user?.organisationId),
            getAllCountries(),
            getAllCurrencies(),
            getAllMerchants(user?.organisationId),
            fetchResourceByOrgId(user.organisationId),
          ]);
        console.log(merchants);
        setDropdownData((prev) => ({
          ...prev,
          customerTypes,
          countries,
          currencies,
          merchants,
          resources,
        }));

        // Fetch company codes if organisationId exists
        if (organisationId) {
          try {
            const companyCodes = await getCompanyCodesByOrganisation(
              parseInt(organisationId),
            );
            console.log(companyCodes);
            setDropdownData((prev) => ({
              ...prev,
              companyCodes,
            }));
          } catch (error) {
            toast.error("🦄 Failed to load company codes!");
          }
        }
      } catch (error) {
        toast.error(`Error loading dropdown data: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchDropdownData();
  }, []);

  // Fetch regions when country changes
  useEffect(() => {
    const fetchRegions = async () => {
      if (customerData.countryCode) {
        try {
          const regions = await getRegionsByCountry(customerData.countryCode);
          setDropdownData((prev) => ({
            ...prev,
            regions,
          }));
          // Reset dependent fields when country changes
          setCustomerData((prev) => ({
            ...prev,
            regionName: "",
            districtName: "",
            tehsilName: "",
            cityName: "",
            registeredInGst: "",
            taxId: "",
          }));
          setLocationCodes((prev) => ({
            ...prev,
            regionCode: "",
            districtCode: "",
            tehsilCode: "",
            cityCode: "",
          }));
          setDropdownData((prev) => ({
            ...prev,
            districts: [],
            tehsils: [],
            cities: [],
          }));
          setShowGstFields(customerData.countryCode === "IN");
          setShowTaxId(false);
        } catch (error) {
          toast.error("🦄 Failed to load regions!");
        }
      } else {
        setDropdownData((prev) => ({
          ...prev,
          regions: [],
          districts: [],
          tehsils: [],
          cities: [],
        }));
        setCustomerData((prev) => ({
          ...prev,
          regionName: "",
          districtName: "",
          tehsilName: "",
          cityName: "",
          registeredInGst: "",
          taxId: "",
        }));
        setLocationCodes((prev) => ({
          ...prev,
          regionCode: "",
          districtCode: "",
          tehsilCode: "",
          cityCode: "",
        }));
        setShowGstFields(false);
        setShowTaxId(false);
      }
    };
    fetchRegions();
  }, [customerData.countryCode]);

  // Fetch districts when region changes
  useEffect(() => {
    const fetchDistricts = async () => {
      if (customerData.regionName) {
        try {
          // Extract region code from the selected value (format: "code - name")
          const regionCode = customerData.regionName.split(" - ")[0];
          const districts = await getDistrictsByRegion(regionCode);
          setDropdownData((prev) => ({
            ...prev,
            districts,
          }));
          // Reset dependent fields when region changes
          setCustomerData((prev) => ({
            ...prev,
            districtName: "",
            tehsilName: "",
            cityName: "",
          }));
          setLocationCodes((prev) => ({
            ...prev,
            districtCode: "",
            tehsilCode: "",
            cityCode: "",
          }));
          setDropdownData((prev) => ({
            ...prev,
            tehsils: [],
            cities: [],
          }));
        } catch (error) {
          toast.error("🦄 Failed to load districts!");
        }
      } else {
        setDropdownData((prev) => ({
          ...prev,
          districts: [],
          tehsils: [],
          cities: [],
        }));
        setCustomerData((prev) => ({
          ...prev,
          districtName: "",
          tehsilName: "",
          cityName: "",
        }));
        setLocationCodes((prev) => ({
          ...prev,
          districtCode: "",
          tehsilCode: "",
          cityCode: "",
        }));
      }
    };
    fetchDistricts();
  }, [customerData.regionName]);

  // Fetch tehsils when district changes
  useEffect(() => {
    const fetchTehsils = async () => {
      if (customerData.districtName) {
        try {
          // Extract district code from the selected value (format: "code - description")
          const districtCode = customerData.districtName.split(" - ")[0];
          const tehsils = await getTehsilsByDistrict(districtCode);
          setDropdownData((prev) => ({
            ...prev,
            tehsils,
          }));
          // Reset dependent fields when district changes
          setCustomerData((prev) => ({
            ...prev,
            tehsilName: "",
            cityName: "",
          }));
          setLocationCodes((prev) => ({
            ...prev,
            tehsilCode: "",
            cityCode: "",
          }));
          setDropdownData((prev) => ({
            ...prev,
            cities: [],
          }));
        } catch (error) {
          toast.error("🦄 Failed to load tehsils!");
        }
      } else {
        setDropdownData((prev) => ({
          ...prev,
          tehsils: [],
          cities: [],
        }));
        setCustomerData((prev) => ({
          ...prev,
          tehsilName: "",
          cityName: "",
        }));
        setLocationCodes((prev) => ({
          ...prev,
          tehsilCode: "",
          cityCode: "",
        }));
      }
    };
    fetchTehsils();
  }, [customerData.districtName]);

  // Fetch cities when tehsil changes
  useEffect(() => {
    const fetchCities = async () => {
      if (customerData.tehsilName) {
        try {
          // Extract tehsil code from the selected value (format: "code - description")
          const tehsilCode = customerData.tehsilName.split(" - ")[0];
          const cities = await getCitiesByTehsil(tehsilCode);
          setDropdownData((prev) => ({
            ...prev,
            cities,
          }));
          // Reset city when tehsil changes
          setCustomerData((prev) => ({
            ...prev,
            cityName: "",
          }));
          setLocationCodes((prev) => ({
            ...prev,
            cityCode: "",
          }));
        } catch (error) {
          toast.error("🦄 Failed to load cities!");
        }
      } else {
        setDropdownData((prev) => ({
          ...prev,
          cities: [],
        }));
        setCustomerData((prev) => ({
          ...prev,
          cityName: "",
        }));
        setLocationCodes((prev) => ({
          ...prev,
          cityCode: "",
        }));
      }
    };
    fetchCities();
  }, [customerData.tehsilName]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "countryCode") {
      setShowGstFields(value === "IN");
      if (value !== "IN") {
        setCustomerData((prev) => ({
          ...prev,
          registeredInGst: "",
          taxId: "",
        }));
        setShowTaxId(false);
      }
    }

    if (name === "registeredInGst") {
      setShowTaxId(value === "Yes");
      if (value !== "Yes") {
        setCustomerData((prev) => ({ ...prev, taxId: "" }));
      }
    }

    // Handle location fields to extract and store codes
    if (name === "regionName") {
      const code = value.split(" - ")[0];
      setLocationCodes((prev) => ({ ...prev, regionCode: code }));
    } else if (name === "districtName") {
      const code = value.split(" - ")[0];
      setLocationCodes((prev) => ({ ...prev, districtCode: code }));
    } else if (name === "tehsilName") {
      const code = value.split(" - ")[0];
      setLocationCodes((prev) => ({ ...prev, tehsilCode: code }));
    } else if (name === "cityName") {
      const code = value.split(" - ")[0];
      setLocationCodes((prev) => ({ ...prev, cityCode: code }));
    }

    setCustomerData({
      ...customerData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if organisationId is available
    if (!organisationId) {
      toast.error("🦄 Error: Organisation ID not found in user details");
      return;
    }

    setLoading(true);
    try {
      // Prepare data for submission with codes only
      const submissionData = {
        ...customerData,
        organisationId: parseInt(organisationId), // Ensure it's a number
        regionName: locationCodes.regionCode,
        districtName: locationCodes.districtCode,
        tehsilName: locationCodes.tehsilCode,
        cityName: locationCodes.cityCode,
      };

      await saveCustomerDetails(submissionData, userId);
      toast.success(`🦄 Customer Added Successfully`);
      setCustomerData({
        organisationId: organisationId,
        companyCode: "",
        customerType1: "",
        name: "",
        countryCode: "",
        regionName: "",
        districtName: "",
        tehsilName: "",
        cityName: "",
        registeredInGst: "",
        taxId: "",
        address1: "",
        address2: "",
        address3: "",
        clientBy: "",
        parentAccount: "",
        defaultTdsPercent: "",
        currency: "",
        paymentTransaction: "",
        active: "",
        shortNames: "",
        vendorCode: "",
        salespersonCode: "",
        leadType: "",
        leadReference: "",
        currentAccountManager: "",
        creditLimit: "1",
        mobileNumber: "",
        pinCode: "",
      });
      setLocationCodes({
        regionCode: "",
        districtCode: "",
        tehsilCode: "",
        cityCode: "",
      });
      setShowGstFields(false);
      setShowTaxId(false);
    } catch (error) {
      toast.error(
        `🦄 Error: ${error.message || "Failed to save customer details"}`,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container customer-master-fields">
      <h2 className="fields-title">Customer Master</h2>

      <Accordion defaultActiveKey="0" className="customer-master-accordion">
        <AccordionItem eventKey="0">
          <AccordionBody>
            <Form onSubmit={handleSubmit} className="fields-form">
              {/* Organisation ID as readonly field */}

              <Row>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Organisation ID <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="organisationId"
                      value={customerData.organisationId}
                      readOnly
                      required
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Company Code <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Select
                      name="companyCode"
                      value={customerData.companyCode}
                      onChange={handleChange}
                      required
                      disabled={!organisationId}
                    >
                      <option value="">Select Company Code</option>
                      {dropdownData.companyCodes.map((company) => (
                        <option
                          key={company.companyCode}
                          value={company.companyCode}
                        >
                          {company.companyCode} - {company.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Customer Type <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Select
                      name="customerType1"
                      value={customerData.customerType1}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Customer Type</option>
                      {dropdownData.customerTypes.map((type) => (
                        <option key={type.code} value={type.code}>
                          {type.code} - {type.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Name <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={customerData.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Credit Limit</Form.Label>
                    <Form.Control
                      type="text"
                      name="creditLimit"
                      value={customerData.creditLimit}
                      placeholder="In Rupees"
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      Country Code <span className="text-red">*</span>
                    </Form.Label>
                    <Form.Select
                      name="countryCode"
                      value={customerData.countryCode}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Country</option>
                      {dropdownData.countries.map((country) => (
                        <option
                          key={country.countryCode}
                          value={country.countryCode}
                        >
                          {country.countryCode} - {country.countryName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Region Code</Form.Label>
                    <Form.Select
                      name="regionName"
                      value={customerData.regionName}
                      onChange={handleChange}
                      disabled={!customerData.countryCode}
                    >
                      <option value="">Select Region</option>
                      {dropdownData.regions.map((region) => (
                        <option
                          key={region.regionCode}
                          value={`${region.regionCode} - ${region.regionName}`}
                        >
                          {region.regionCode} - {region.regionName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>District Code</Form.Label>
                    <Form.Select
                      name="districtName"
                      value={customerData.districtName}
                      onChange={handleChange}
                      disabled={!customerData.regionName}
                    >
                      <option value="">Select District</option>
                      {dropdownData.districts.map((district) => (
                        <option
                          key={district.code}
                          value={`${district.code} - ${district.description}`}
                        >
                          {district.code} - {district.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tehsil Code</Form.Label>
                    <Form.Select
                      name="tehsilName"
                      value={customerData.tehsilName}
                      onChange={handleChange}
                      disabled={!customerData.districtName}
                    >
                      <option value="">Select Tehsil</option>
                      {dropdownData.tehsils.map((tehsil) => (
                        <option
                          key={tehsil.code}
                          value={`${tehsil.code} - ${tehsil.description}`}
                        >
                          {tehsil.code} - {tehsil.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>City Name</Form.Label>
                    <Form.Select
                      name="cityName"
                      value={customerData.cityName}
                      onChange={handleChange}
                      disabled={!customerData.tehsilName}
                    >
                      <option value="">Select City</option>
                      {dropdownData.cities.map((city) => (
                        <option
                          key={city.code}
                          value={`${city.code} - ${city.description}`}
                        >
                          {city.code} - {city.description}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                {showGstFields && (
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Registered in GST <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Select
                        name="registeredInGst"
                        value={customerData.registeredInGst}
                        onChange={handleChange}
                        required={showGstFields}
                      >
                        <option value="">Select Option</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                )}
                {showTaxId && (
                  <Col xl={4} lg={4} md={6} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Tax ID <span className="text-red">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="taxId"
                        value={customerData.taxId}
                        onChange={handleChange}
                        required={showTaxId}
                      />
                    </Form.Group>
                  </Col>
                )}
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address 1</Form.Label>
                    <Form.Control
                      type="text"
                      name="address1"
                      value={customerData.address1}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address 2</Form.Label>
                    <Form.Control
                      type="text"
                      name="address2"
                      value={customerData.address2}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address 3</Form.Label>
                    <Form.Control
                      type="text"
                      name="address3"
                      value={customerData.address3}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>PinCode</Form.Label>
                    <Form.Control
                      type="text"
                      name="pinCode"
                      value={customerData.pinCode}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="mobileNumber"
                      value={customerData.mobileNumber}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Client By</Form.Label>
                    <Form.Control
                      type="text"
                      name="clientBy"
                      value={customerData.clientBy}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Parent Account</Form.Label>
                    <Form.Control
                      type="text"
                      name="parentAccount"
                      value={customerData.parentAccount}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Default TDS Percent</Form.Label>
                    <Form.Control
                      type="text"
                      name="defaultTdsPercent"
                      value={customerData.defaultTdsPercent}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Currency</Form.Label>
                    <Form.Select
                      name="currency"
                      value={customerData.currency}
                      onChange={handleChange}
                    >
                      <option value="">Select Currency</option>
                      {dropdownData.currencies.map((currency) => (
                        <option
                          key={currency.currencyCode}
                          value={currency.currencyCode}
                        >
                          {currency.currencyCode} - {currency.currencyName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Payment Transaction</Form.Label>
                    <Form.Control
                      type="text"
                      name="paymentTransaction"
                      value={customerData.paymentTransaction}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Active</Form.Label>
                    <Form.Select
                      name="active"
                      value={customerData.active}
                      onChange={handleChange}
                    >
                      <option value="">Select Option</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Short Names</Form.Label>
                    <Form.Control
                      type="text"
                      name="shortNames"
                      value={customerData.shortNames}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Vendor Code</Form.Label>
                    <Form.Select
                      name="vendorCode"
                      value={customerData.vendorCode}
                      onChange={handleChange}
                    >
                      <option value="">Select Vendor</option>
                      {dropdownData.merchants.map((merchant) => (
                        <option
                          key={merchant.vendorCode}
                          value={merchant.vendorCode}
                        >
                          {merchant.vendorCode} - {merchant.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Salesperson Code</Form.Label>
                    <Form.Select
                      name="salespersonCode"
                      value={customerData.salespersonCode}
                      onChange={handleChange}
                    >
                      <option value="">Select Salesperson</option>
                      {dropdownData.resources.map((resource) => (
                        <option
                          key={resource.resourceId}
                          value={resource.resourceId}
                        >
                          {resource.resourceId} - {resource.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Lead Type</Form.Label>
                    <Form.Control
                      type="text"
                      name="leadType"
                      value={customerData.leadType}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Lead Reference</Form.Label>
                    <Form.Control
                      type="text"
                      name="leadReference"
                      value={customerData.leadReference}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={6} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Current Account Manager</Form.Label>
                    <Form.Select
                      name="currentAccountManager"
                      value={customerData.currentAccountManager}
                      onChange={handleChange}
                    >
                      <option value="">Select Account Manager</option>
                      {dropdownData.resources.map((resource) => (
                        <option
                          key={resource.resourceId}
                          value={resource.resourceId}
                        >
                          {resource.resourceId} - {resource.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <div className="fields-btn-container" style={{ marginTop: 16 }}>
                <Button
                  variant="primary"
                  type="submit"
                  className="fields-submit"
                  disabled={loading || !organisationId}
                >
                  {loading ? "Saving..." : "Save Customer"}
                </Button>
              </div>
            </Form>
          </AccordionBody>
        </AccordionItem>
      </Accordion>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </div>
  );
};

export default CustomerMaster;
